// import React, { useEffect, useState } from "react";
// import "./Usermanagement.css";
// import { Link } from "react-router-dom";

// const PostPaidUsers = () => {
//     const [selectedCustomer, setSelectedCustomer] = useState(null);
//     const [data, setData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [loadingStates, setLoadingStates] = useState({}); // Track loading for each user

//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     useEffect(() => {
//         const controller = new AbortController();
//         const authToken = localStorage.getItem("authToken");

//         const fetchUsers = async () => {
//             try {
//                 const res = await fetch(
//                     "https://backend.maamaas.com/subscription/api/admin/postpaid/approvals",
//                     {
//                         signal: controller.signal,
//                         headers: {
//                             "Content-Type": "application/json",
//                             "Authorization": `Bearer ${authToken}`,
//                         },
//                     }
//                 );

//                 if (!res.ok) {
//                     throw new Error(`HTTP error! status: ${res.status}`);
//                 }

//                 const fetchedData = await res.json();

//                 // Format the data dynamically
//                 const formattedData = fetchedData
//                     .filter(item => 
//                         item.professionalUserId && 
//                         item.professionalUserName && 
//                         item.companyName && 
//                         item.restaurants
//                     )
//                     .map((item, index) => ({
//                         sno: index + 1,
//                         professionalUserId: item.professionalUserId,
//                         professionalUserName: item.professionalUserName,
//                         companyName: item.companyName,
//                         restaurants: item.restaurants, // Keep as object
//                         userType: "PROFESSIONAL"
//                     }));

//                 setData(formattedData);
//             } catch (err) {
//                 if (err.name !== "AbortError") {
//                     console.error("Error fetching users:", err);
//                 }
//             }
//         };

//         fetchUsers();

//         return () => controller.abort();
//     }, []);

//     // Helper function to get overall approval status from restaurants object
//     const getOverallStatus = (restaurants) => {
//         if (!restaurants || typeof restaurants !== 'object') {
//             return "PENDING";
//         }

//         const restaurantEntries = Object.entries(restaurants);
//         if (restaurantEntries.length === 0) {
//             return "PENDING";
//         }

//         // Get all approval statuses
//         const statuses = restaurantEntries.map(([key, restaurant]) => {
//             const status = restaurant?.approvalStatus;
//             // Ensure we return a valid status string
//             return status && typeof status === 'string' ? status : "PENDING";
//         });

//         // Check if all statuses are the same
//         const firstStatus = statuses[0];
//         const allSame = statuses.every(status => status === firstStatus);

//         // If not all same, return PENDING instead of MIXED
//         return allSame ? firstStatus : "PENDING";
//     };

//     // Helper function to get restaurant names
//     const getRestaurantNames = (restaurants) => {
//         if (!restaurants || typeof restaurants !== 'object') {
//             return "No restaurants";
//         }

//         return Object.values(restaurants)
//             .map(restaurant => restaurant?.restaurantName || "Unnamed Restaurant")
//             .join(', ');
//     };

//     // Helper function to get restaurant count
//     const getRestaurantCount = (restaurants) => {
//         if (!restaurants || typeof restaurants !== 'object') {
//             return 0;
//         }
//         return Object.keys(restaurants).length;
//     };

//     const handleApprove = async (userId) => {
//         const authToken = localStorage.getItem("authToken");
        
//         setLoadingStates(prev => ({ ...prev, [`approve_${userId}`]: true }));

//         try {
//             // Get user data to find restaurant names
//             const user = data.find(u => u.professionalUserId === userId);
//             if (!user || !user.restaurants) {
//                 throw new Error("User or restaurants not found");
//             }

//             // Update each restaurant individually
//             const restaurantKeys = Object.keys(user.restaurants);
//             console.log("Approving restaurants for user:", userId, "Restaurants:", restaurantKeys);
            
//             const updateResults = [];
            
//             for (const restaurantKey of restaurantKeys) {
//                 const restaurant = user.restaurants[restaurantKey];
//                 const restaurantName = restaurant?.restaurantName || restaurantKey;
                
//                 // Debug: Log the URL being called
//                 const updateUrl = `https://backend.maamaas.com/subscription/api/admin/postpaid/approval/update?professionalUserId=${userId}&restaurantName=${encodeURIComponent(restaurantName)}&status=APPROVED`;
//                 console.log("Calling PUT API:", updateUrl);
                
//                 try {
//                     const response = await fetch(updateUrl, {
//                         method: "PUT",
//                         headers: {
//                             "Content-Type": "application/json",
//                             "Authorization": `Bearer ${authToken}`,
//                         },
//                     });

//                     console.log("Response status:", response.status);
                    
//                     if (response.ok) {
//                         try {
//                             const result = await response.json();
//                             console.log("API Success Response:", result);
//                             updateResults.push({ restaurantName, success: true, data: result });
//                         } catch (jsonError) {
//                             // If response is empty or not JSON, that's OK - it might be a successful PUT
//                             console.log("Response is not JSON (might be empty):", response.status);
//                             updateResults.push({ restaurantName, success: true, status: response.status });
//                         }
//                     } else {
//                         // Try to read error response
//                         let errorMessage = `Status: ${response.status}`;
//                         try {
//                             const errorText = await response.text();
//                             if (errorText) {
//                                 errorMessage = errorText;
//                             }
//                         } catch (e) {
//                             // Ignore if we can't read error text
//                         }
//                         console.error("API Error:", errorMessage);
//                         updateResults.push({ restaurantName, success: false, error: errorMessage });
//                     }
//                 } catch (fetchError) {
//                     console.error("Fetch error:", fetchError);
//                     updateResults.push({ restaurantName, success: false, error: fetchError.message });
//                 }
//             }

//             // Check if all updates were successful
//             const allSuccessful = updateResults.every(result => result.success);
//             const failedUpdates = updateResults.filter(result => !result.success);

//             if (!allSuccessful && failedUpdates.length > 0) {
//                 console.warn("Some updates failed:", failedUpdates);
//                 // Still update UI for successful ones
//             }

//             // Update the local state - update all restaurants for this user
//             setData(prevData => 
//                 prevData.map(user => {
//                     if (user.professionalUserId === userId) {
//                         // Create updated restaurants object with all statuses as APPROVED
//                         const updatedRestaurants = {};
//                         Object.keys(user.restaurants).forEach(key => {
//                             updatedRestaurants[key] = {
//                                 ...user.restaurants[key],
//                                 approvalStatus: "APPROVED"
//                             };
//                         });
                        
//                         return {
//                             ...user,
//                             restaurants: updatedRestaurants
//                         };
//                     }
//                     return user;
//                 })
//             );

//             // Show appropriate message
//             if (allSuccessful) {
//                 alert("Successfully approved all restaurants!");
//             } else {
//                 alert(`Partially successful. ${updateResults.length - failedUpdates.length} restaurants approved, ${failedUpdates.length} failed. Check console for details.`);
//             }
//         } catch (error) {
//             console.error("Error in approve function:", error);
//             alert(`Failed to approve. Error: ${error.message}`);
//         } finally {
//             setLoadingStates(prev => ({ ...prev, [`approve_${userId}`]: false }));
//         }
//     };

//     const handleReject = async (userId) => {
//         const authToken = localStorage.getItem("authToken");
        
//         setLoadingStates(prev => ({ ...prev, [`reject_${userId}`]: true }));

//         try {
//             // Get user data to find restaurant names
//             const user = data.find(u => u.professionalUserId === userId);
//             if (!user || !user.restaurants) {
//                 throw new Error("User or restaurants not found");
//             }

//             // Update each restaurant individually
//             const restaurantKeys = Object.keys(user.restaurants);
//             console.log("Rejecting restaurants for user:", userId, "Restaurants:", restaurantKeys);
            
//             const updateResults = [];
            
//             for (const restaurantKey of restaurantKeys) {
//                 const restaurant = user.restaurants[restaurantKey];
//                 const restaurantName = restaurant?.restaurantName || restaurantKey;
                
//                 // Debug: Log the URL being called
//                 const updateUrl = `https://backend.maamaas.com/subscription/api/admin/postpaid/approval/update?professionalUserId=${userId}&restaurantName=${encodeURIComponent(restaurantName)}&status=REJECTED`;
//                 console.log("Calling PUT API:", updateUrl);
                
//                 try {
//                     const response = await fetch(updateUrl, {
//                         method: "PUT",
//                         headers: {
//                             "Content-Type": "application/json",
//                             "Authorization": `Bearer ${authToken}`,
//                         },
//                     });

//                     console.log("Response status:", response.status);
                    
//                     if (response.ok) {
//                         try {
//                             const result = await response.json();
//                             console.log("API Success Response:", result);
//                             updateResults.push({ restaurantName, success: true, data: result });
//                         } catch (jsonError) {
//                             // If response is empty or not JSON, that's OK - it might be a successful PUT
//                             console.log("Response is not JSON (might be empty):", response.status);
//                             updateResults.push({ restaurantName, success: true, status: response.status });
//                         }
//                     } else {
//                         // Try to read error response
//                         let errorMessage = `Status: ${response.status}`;
//                         try {
//                             const errorText = await response.text();
//                             if (errorText) {
//                                 errorMessage = errorText;
//                             }
//                         } catch (e) {
//                             // Ignore if we can't read error text
//                         }
//                         console.error("API Error:", errorMessage);
//                         updateResults.push({ restaurantName, success: false, error: errorMessage });
//                     }
//                 } catch (fetchError) {
//                     console.error("Fetch error:", fetchError);
//                     updateResults.push({ restaurantName, success: false, error: fetchError.message });
//                 }
//             }

//             // Check if all updates were successful
//             const allSuccessful = updateResults.every(result => result.success);
//             const failedUpdates = updateResults.filter(result => !result.success);

//             if (!allSuccessful && failedUpdates.length > 0) {
//                 console.warn("Some updates failed:", failedUpdates);
//                 // Still update UI for successful ones
//             }

//             // Update the local state - update all restaurants for this user
//             setData(prevData => 
//                 prevData.map(user => {
//                     if (user.professionalUserId === userId) {
//                         // Create updated restaurants object with all statuses as REJECTED
//                         const updatedRestaurants = {};
//                         Object.keys(user.restaurants).forEach(key => {
//                             updatedRestaurants[key] = {
//                                 ...user.restaurants[key],
//                                 approvalStatus: "REJECTED"
//                             };
//                         });
                        
//                         return {
//                             ...user,
//                             restaurants: updatedRestaurants
//                         };
//                     }
//                     return user;
//                 })
//             );

//             // Show appropriate message
//             if (allSuccessful) {
//                 alert("Successfully rejected all restaurants!");
//             } else {
//                 alert(`Partially successful. ${updateResults.length - failedUpdates.length} restaurants rejected, ${failedUpdates.length} failed. Check console for details.`);
//             }
//         } catch (error) {
//             console.error("Error in reject function:", error);
//             alert(`Failed to reject. Error: ${error.message}`);
//         } finally {
//             setLoadingStates(prev => ({ ...prev, [`reject_${userId}`]: false }));
//         }
//     };

//     const handleExport = () => {
//         if (data.length === 0) {
//             alert("There is no data to export.");
//             return;
//         }

//         const escapeCsvField = (field) => {
//             const str = String(field ?? '');
//             if (str.includes(',') || str.includes('"') || str.includes('\n')) {
//                 return `"${str.replace(/"/g, '""')}"`;
//             }
//             return str;
//         };

//         const headers = [
//             "S.NO",
//             "Professional User ID",
//             "Professional User Name",
//             "Company Name",
//             "Restaurants Count",
//             "Restaurant Names",
//             "Approval Status"
//         ];

//         const csvRows = data.map((user) => {
//             const restaurantNames = getRestaurantNames(user.restaurants);
//             const overallStatus = getOverallStatus(user.restaurants);
//             const restaurantCount = getRestaurantCount(user.restaurants);

//             return [
//                 user.sno,
//                 user.professionalUserId,
//                 user.professionalUserName,
//                 user.companyName,
//                 restaurantCount,
//                 restaurantNames,
//                 overallStatus
//             ];
//         });

//         const csvString = [
//             headers.map(escapeCsvField).join(','),
//             ...csvRows.map(row => row.map(escapeCsvField).join(','))
//         ].join('\r\n');

//         const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.setAttribute("href", url);
//         link.setAttribute("download", "professional_users.csv");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         URL.revokeObjectURL(url);
//     };

//     const openModal = (user) => setSelectedCustomer(user);
//     const closeModal = () => setSelectedCustomer(null);

//     return (
//         <div className="container-fluid p-0 client-managment-data">
//             <div className="row g-0" style={{ marginTop: '-10px', height: "92vh" }}>
//                 <div className=""></div>
//                 <div className="">
//                     <p
//                         className="breadcrumb maamaas-home-bredcum or20"
//                         style={{
//                             position: "fixed",
//                             top: "59px",
//                             left: "1vw",
//                             width: "100%",
//                             backgroundColor: "#fff",
//                             padding: "10px 0",
//                             fontSize: "18px",
//                             fontWeight: "bold",
//                             textAlign: "center",
//                             margin: 0,
//                         }}
//                     >
//                         <Link
//                             to="/Homes"
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Home
//                         </Link>

//                         <span className="separator"> &gt; </span>
//                         <span
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             User_Management
//                         </span>
//                         <span className="separator"> &gt; </span>
//                         <span
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Post Paid Users
//                         </span>
//                     </p>
                    
//                     {/* Main Content Container - Scrollable area */}
//                     <div
//                         style={{
//                             height: `calc(100vh - 75px)`,
//                             overflowY: "auto",
//                             scrollbarWidth: "none",
//                             padding: "10px",
//                         }}
//                         className=""
//                     >
//                         <style>{`
//               div::-webkit-scrollbar { 
//                 display: none; 
//               }
//             `}</style>
                        
//                         {/* User Management Content */}
//                         <div className="user-management-container" style={{ marginTop: '20px' }}>
//                             <div className="row g-2 mb-1 align-items-center me-0">
//                                 <div className="col-md col-12">
//                                     <div className="d-flex justify-content-start justify-content-md-end">
//                                         <button 
//                                             className="btn" 
//                                             onClick={handleExport} 
//                                             style={{ backgroundColor: '#b15cd6', color: '#fff' }}
//                                         >
//                                             Export
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="user-table-wrapper" style={{ height: "500px", overflow: "auto" }}>
//                                 <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
//                                     <thead>
//                                         <tr>
//                                             <th style={tableHeaderStyle}>S.NO</th>
//                                             <th style={tableHeaderStyle}>Professional User ID</th>
//                                             <th style={tableHeaderStyle}>Professional User Name</th>
//                                             <th style={tableHeaderStyle}>Company Name</th>
//                                             <th style={tableHeaderStyle}>Restaurants</th>
//                                             <th style={tableHeaderStyle}>Approval Status</th>
//                                             <th style={tableHeaderStyle}>Actions</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {data.length > 0 ? (
//                                             data.map((user, index) => {
//                                                 const overallStatus = getOverallStatus(user.restaurants);
//                                                 const approveLoading = loadingStates[`approve_${user.professionalUserId}`];
//                                                 const rejectLoading = loadingStates[`reject_${user.professionalUserId}`];
                                                
//                                                 return (
//                                                     <tr
//                                                         key={user.professionalUserId || user.sno}
//                                                         style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
//                                                     >
//                                                         <td style={tableCellStyle}>{user.sno}</td>
//                                                         <td style={tableCellStyle}>{user.professionalUserId}</td>
//                                                         <td style={tableCellStyle}>{user.professionalUserName}</td>
//                                                         <td style={tableCellStyle}>{user.companyName}</td>
//                                                         <td style={tableCellStyle}>
//                                                             {getRestaurantNames(user.restaurants)}
//                                                         </td>
//                                                         <td style={tableCellStyle}>
//                                                             <span style={{
//                                                                 padding: '2px 8px',
//                                                                 borderRadius: '12px',
//                                                                 fontSize: '0.85rem',
//                                                                 fontWeight: 'bold',
//                                                                 backgroundColor: 
//                                                                     overallStatus === 'APPROVED' ? '#d4edda' :
//                                                                     overallStatus === 'REJECTED' ? '#f8d7da' :
//                                                                     overallStatus === 'PENDING' ? '#fff3cd' : '#e2e3e5',
//                                                                 color: 
//                                                                     overallStatus === 'APPROVED' ? '#155724' :
//                                                                     overallStatus === 'REJECTED' ? '#721c24' :
//                                                                     overallStatus === 'PENDING' ? '#856404' : '#383d41'
//                                                             }}>
//                                                                 {overallStatus || "PENDING"}
//                                                             </span>
//                                                         </td>
//                                                         <td style={tableCellStyle}>
//                                                             <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
//                                                                 {/* Show Approve button if status is not APPROVED (can be REJECTED, PENDING, or MIXED) */}
//                                                                 {overallStatus !== 'APPROVED' && (
//                                                                     <button
//                                                                         onClick={() => handleApprove(user.professionalUserId)}
//                                                                         disabled={approveLoading}
//                                                                         style={{
//                                                                             backgroundColor: '#28a745',
//                                                                             color: 'white',
//                                                                             border: 'none',
//                                                                             padding: '4px 12px',
//                                                                             borderRadius: '4px',
//                                                                             cursor: approveLoading ? 'not-allowed' : 'pointer',
//                                                                             opacity: approveLoading ? 0.6 : 1,
//                                                                             fontSize: '0.85rem'
//                                                                         }}
//                                                                     >
//                                                                         {approveLoading ? 'Approving...' : 'Approve'}
//                                                                     </button>
//                                                                 )}
                                                                
//                                                                 {/* Show Reject button only if status is PENDING (not when APPROVED or REJECTED) */}
//                                                                 {overallStatus === 'PENDING' && (
//                                                                     <button
//                                                                         onClick={() => handleReject(user.professionalUserId)}
//                                                                         disabled={rejectLoading}
//                                                                         style={{
//                                                                             backgroundColor: '#dc3545',
//                                                                             color: 'white',
//                                                                             border: 'none',
//                                                                             padding: '4px 12px',
//                                                                             borderRadius: '4px',
//                                                                             cursor: rejectLoading ? 'not-allowed' : 'pointer',
//                                                                             opacity: rejectLoading ? 0.6 : 1,
//                                                                             fontSize: '0.85rem'
//                                                                         }}
//                                                                     >
//                                                                         {rejectLoading ? 'Rejecting...' : 'Reject'}
//                                                                     </button>
//                                                                 )}
                                                                
//                                                                 {/* Show a status message when already approved */}
//                                                                 {overallStatus === 'APPROVED' && (
//                                                                     <span style={{
//                                                                         color: '#155724',
//                                                                         fontSize: '0.85rem',
//                                                                         fontWeight: 'bold',
//                                                                         padding: '4px 8px'
//                                                                     }}>
//                                                                         ✓ Approved
//                                                                     </span>
//                                                                 )}
                                                                
//                                                                 {/* Show a status message when rejected */}
//                                                                 {overallStatus === 'REJECTED' && (
//                                                                     <span style={{
//                                                                         color: '#721c24',
//                                                                         fontSize: '0.85rem',
//                                                                         fontWeight: 'bold',
//                                                                         padding: '4px 8px'
//                                                                     }}>
//                                                                         ✗ Rejected
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 );
//                                             })
//                                         ) : (
//                                             <tr>
//                                                 <td colSpan="7" style={noDataStyle}>
//                                                     Loading data or no professional users found.
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const tableHeaderStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     fontWeight: "bold",
//     backgroundColor: "#b15cd6",
//     color: "white",
//     padding: "6px",
// };

// const tableCellStyle = {
//     border: "1px solid #ddd",
//     textAlign: "center",
//     padding: "6px",
// };

// const noDataStyle = {
//     fontStyle: "italic",
//     textAlign: "center",
//     padding: "10px",
//     color: "#888",
// };

// export default PostPaidUsers;





















import React, { useEffect, useState, useMemo } from "react";
import "./Usermanagement.css";
import { Link } from "react-router-dom";

const PostPaidUsers = () => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [loadingStates, setLoadingStates] = useState({}); // Track loading for each user
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [searchType, setSearchType] = useState("professionalUserId"); // Default search type
    const [searchQuery, setSearchQuery] = useState("");

    // Search options for dropdown
    const searchOptions = [
        { value: "professionalUserId", label: "User ID" },
        { value: "professionalUserName", label: "User Name" },
        { value: "companyName", label: "Company Name" },
    ];

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const authToken = localStorage.getItem("authToken");

        const fetchUsers = async () => {
            try {
                const res = await fetch(
                    "https://backend.maamaas.com/subscription/api/admin/postpaid/approvals",
                    {
                        signal: controller.signal,
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${authToken}`,
                        },
                    }
                );

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }

                const fetchedData = await res.json();

                // Format the data dynamically
                const formattedData = fetchedData
                    .filter(item => 
                        item.professionalUserId && 
                        item.professionalUserName && 
                        item.companyName && 
                        item.restaurants
                    )
                    .map((item, index) => ({
                        sno: index + 1,
                        professionalUserId: item.professionalUserId,
                        professionalUserName: item.professionalUserName,
                        companyName: item.companyName,
                        restaurants: item.restaurants, // Keep as object
                        userType: "PROFESSIONAL"
                    }));

                setData(formattedData);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Error fetching users:", err);
                }
            }
        };

        fetchUsers();

        return () => controller.abort();
    }, []);

    // Helper function to get overall approval status from restaurants object
    const getOverallStatus = (restaurants) => {
        if (!restaurants || typeof restaurants !== 'object') {
            return "PENDING";
        }

        const restaurantEntries = Object.entries(restaurants);
        if (restaurantEntries.length === 0) {
            return "PENDING";
        }

        // Get all approval statuses
        const statuses = restaurantEntries.map(([key, restaurant]) => {
            const status = restaurant?.approvalStatus;
            // Ensure we return a valid status string
            return status && typeof status === 'string' ? status : "PENDING";
        });

        // Check if all statuses are the same
        const firstStatus = statuses[0];
        const allSame = statuses.every(status => status === firstStatus);

        // If not all same, return PENDING instead of MIXED
        return allSame ? firstStatus : "PENDING";
    };

    // Helper function to get restaurant names
    const getRestaurantNames = (restaurants) => {
        if (!restaurants || typeof restaurants !== 'object') {
            return "No restaurants";
        }

        return Object.values(restaurants)
            .map(restaurant => restaurant?.restaurantName || "Unnamed Restaurant")
            .join(', ');
    };

    // Helper function to get restaurant count
    const getRestaurantCount = (restaurants) => {
        if (!restaurants || typeof restaurants !== 'object') {
            return 0;
        }
        return Object.keys(restaurants).length;
    };

    // Filter data based on selected search type and query
    const searchFilteredData = useMemo(() => {
        if (!searchQuery.trim()) {
            return data;
        }

        const query = searchQuery.toLowerCase().trim();
        
        return data.filter(user => {
            // Get the correct field based on searchType
            const fieldValue = user[searchType];
            
            if (!fieldValue) return false;
            
            return fieldValue.toString().toLowerCase().includes(query);
        });
    }, [data, searchType, searchQuery]);

    // Filter data based on status filter
    const filteredData = useMemo(() => {
        if (!selectedStatusFilter) {
            return searchFilteredData;
        }

        return searchFilteredData.filter(user => {
            const overallStatus = getOverallStatus(user.restaurants);
            return overallStatus === selectedStatusFilter;
        });
    }, [searchFilteredData, selectedStatusFilter]);

    const handleApprove = async (userId) => {
        const authToken = localStorage.getItem("authToken");
        
        setLoadingStates(prev => ({ ...prev, [`approve_${userId}`]: true }));

        try {
            // Get user data to find restaurant names
            const user = data.find(u => u.professionalUserId === userId);
            if (!user || !user.restaurants) {
                throw new Error("User or restaurants not found");
            }

            // Update each restaurant individually
            const restaurantKeys = Object.keys(user.restaurants);
            console.log("Approving restaurants for user:", userId, "Restaurants:", restaurantKeys);
            
            const updateResults = [];
            
            for (const restaurantKey of restaurantKeys) {
                const restaurant = user.restaurants[restaurantKey];
                const restaurantName = restaurant?.restaurantName || restaurantKey;
                
                // Debug: Log the URL being called
                const updateUrl = `https://backend.maamaas.com/subscription/api/admin/postpaid/approval/update?professionalUserId=${userId}&restaurantName=${encodeURIComponent(restaurantName)}&status=APPROVED`;
                console.log("Calling PUT API:", updateUrl);
                
                try {
                    const response = await fetch(updateUrl, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${authToken}`,
                        },
                    });

                    console.log("Response status:", response.status);
                    
                    if (response.ok) {
                        try {
                            const result = await response.json();
                            console.log("API Success Response:", result);
                            updateResults.push({ restaurantName, success: true, data: result });
                        } catch (jsonError) {
                            // If response is empty or not JSON, that's OK - it might be a successful PUT
                            console.log("Response is not JSON (might be empty):", response.status);
                            updateResults.push({ restaurantName, success: true, status: response.status });
                        }
                    } else {
                        // Try to read error response
                        let errorMessage = `Status: ${response.status}`;
                        try {
                            const errorText = await response.text();
                            if (errorText) {
                                errorMessage = errorText;
                            }
                        } catch (e) {
                            // Ignore if we can't read error text
                        }
                        console.error("API Error:", errorMessage);
                        updateResults.push({ restaurantName, success: false, error: errorMessage });
                    }
                } catch (fetchError) {
                    console.error("Fetch error:", fetchError);
                    updateResults.push({ restaurantName, success: false, error: fetchError.message });
                }
            }

            // Check if all updates were successful
            const allSuccessful = updateResults.every(result => result.success);
            const failedUpdates = updateResults.filter(result => !result.success);

            if (!allSuccessful && failedUpdates.length > 0) {
                console.warn("Some updates failed:", failedUpdates);
                // Still update UI for successful ones
            }

            // Update the local state - update all restaurants for this user
            setData(prevData => 
                prevData.map(user => {
                    if (user.professionalUserId === userId) {
                        // Create updated restaurants object with all statuses as APPROVED
                        const updatedRestaurants = {};
                        Object.keys(user.restaurants).forEach(key => {
                            updatedRestaurants[key] = {
                                ...user.restaurants[key],
                                approvalStatus: "APPROVED"
                            };
                        });
                        
                        return {
                            ...user,
                            restaurants: updatedRestaurants
                        };
                    }
                    return user;
                })
            );

            // Show appropriate message
            if (allSuccessful) {
                alert("Successfully approved all restaurants!");
            } else {
                alert(`Partially successful. ${updateResults.length - failedUpdates.length} restaurants approved, ${failedUpdates.length} failed. Check console for details.`);
            }
        } catch (error) {
            console.error("Error in approve function:", error);
            alert(`Failed to approve. Error: ${error.message}`);
        } finally {
            setLoadingStates(prev => ({ ...prev, [`approve_${userId}`]: false }));
        }
    };

    const handleReject = async (userId) => {
        const authToken = localStorage.getItem("authToken");
        
        setLoadingStates(prev => ({ ...prev, [`reject_${userId}`]: true }));

        try {
            // Get user data to find restaurant names
            const user = data.find(u => u.professionalUserId === userId);
            if (!user || !user.restaurants) {
                throw new Error("User or restaurants not found");
            }

            // Update each restaurant individually
            const restaurantKeys = Object.keys(user.restaurants);
            console.log("Rejecting restaurants for user:", userId, "Restaurants:", restaurantKeys);
            
            const updateResults = [];
            
            for (const restaurantKey of restaurantKeys) {
                const restaurant = user.restaurants[restaurantKey];
                const restaurantName = restaurant?.restaurantName || restaurantKey;
                
                // Debug: Log the URL being called
                const updateUrl = `https://backend.maamaas.com/subscription/api/admin/postpaid/approval/update?professionalUserId=${userId}&restaurantName=${encodeURIComponent(restaurantName)}&status=REJECTED`;
                console.log("Calling PUT API:", updateUrl);
                
                try {
                    const response = await fetch(updateUrl, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${authToken}`,
                        },
                    });

                    console.log("Response status:", response.status);
                    
                    if (response.ok) {
                        try {
                            const result = await response.json();
                            console.log("API Success Response:", result);
                            updateResults.push({ restaurantName, success: true, data: result });
                        } catch (jsonError) {
                            // If response is empty or not JSON, that's OK - it might be a successful PUT
                            console.log("Response is not JSON (might be empty):", response.status);
                            updateResults.push({ restaurantName, success: true, status: response.status });
                        }
                    } else {
                        // Try to read error response
                        let errorMessage = `Status: ${response.status}`;
                        try {
                            const errorText = await response.text();
                            if (errorText) {
                                errorMessage = errorText;
                            }
                        } catch (e) {
                            // Ignore if we can't read error text
                        }
                        console.error("API Error:", errorMessage);
                        updateResults.push({ restaurantName, success: false, error: errorMessage });
                    }
                } catch (fetchError) {
                    console.error("Fetch error:", fetchError);
                    updateResults.push({ restaurantName, success: false, error: fetchError.message });
                }
            }

            // Check if all updates were successful
            const allSuccessful = updateResults.every(result => result.success);
            const failedUpdates = updateResults.filter(result => !result.success);

            if (!allSuccessful && failedUpdates.length > 0) {
                console.warn("Some updates failed:", failedUpdates);
                // Still update UI for successful ones
            }

            // Update the local state - update all restaurants for this user
            setData(prevData => 
                prevData.map(user => {
                    if (user.professionalUserId === userId) {
                        // Create updated restaurants object with all statuses as REJECTED
                        const updatedRestaurants = {};
                        Object.keys(user.restaurants).forEach(key => {
                            updatedRestaurants[key] = {
                                ...user.restaurants[key],
                                approvalStatus: "REJECTED"
                            };
                        });
                        
                        return {
                            ...user,
                            restaurants: updatedRestaurants
                        };
                    }
                    return user;
                })
            );

            // Show appropriate message
            if (allSuccessful) {
                alert("Successfully rejected all restaurants!");
            } else {
                alert(`Partially successful. ${updateResults.length - failedUpdates.length} restaurants rejected, ${failedUpdates.length} failed. Check console for details.`);
            }
        } catch (error) {
            console.error("Error in reject function:", error);
            alert(`Failed to reject. Error: ${error.message}`);
        } finally {
            setLoadingStates(prev => ({ ...prev, [`reject_${userId}`]: false }));
        }
    };

    // Fixed export function - Export filtered data
    const handleExport = () => {
        const exportData = filteredData.length > 0 ? filteredData : data;
        
        if (exportData.length === 0) {
            alert("There is no data to export.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = [
            "S.NO",
            "Professional User ID",
            "Professional User Name",
            "Company Name",
            "Restaurants Count",
            "Restaurant Names",
            "Approval Status"
        ];

        const csvRows = exportData.map((user) => {
            const restaurantNames = getRestaurantNames(user.restaurants);
            const overallStatus = getOverallStatus(user.restaurants);
            const restaurantCount = getRestaurantCount(user.restaurants);

            return [
                user.sno,
                user.professionalUserId,
                user.professionalUserName,
                user.companyName,
                restaurantCount,
                restaurantNames,
                overallStatus
            ];
        });

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "professional_users.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    // Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "professionalUserId": return "Search User ID";
            case "professionalUserName": return "Search Name";
            case "companyName": return "Search Company";
            default: return "Search...";
        }
    };

    // Clear all search filters
    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedStatusFilter("");
    };

    const openModal = (user) => setSelectedCustomer(user);
    const closeModal = () => setSelectedCustomer(null);

    return (
        <div className="container-fluid p-0 client-managment-data">
            <div className="row g-0" style={{ marginTop: '-10px', height: "92vh" }}>
                <div className=""></div>
                <div className="">
                    <p
                        className="breadcrumb maamaas-home-bredcum or20"
                        style={{
                            position: "fixed",
                            top: "59px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            User_Management
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Post Paid Users
                        </span>
                    </p>
                    
                    {/* Main Content Container - Scrollable area */}
                    <div
                        style={{
                            height: `calc(100vh - 75px)`,
                            overflowY: "auto",
                            scrollbarWidth: "none",
                            padding: "10px",
                        }}
                        className=""
                    >
                        <style>{`
              div::-webkit-scrollbar { 
                display: none; 
              }
            `}</style>
                        
                        {/* User Management Content */}
                        <div className="user-management-container" style={{ marginTop: '20px' }}>
                            {/* Filter Controls - Same as Userdetails */}
                            <div className="row g-2 mb-1 align-items-center me-0">
                                {/* Search Type Dropdown and Search Input - Side by Side */}
                                <div className="col-md-auto col-12">
                                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                        {/* Search Type Dropdown */}
                                        <div style={{ minWidth: '150px' }}>
                                            <select
                                                className="form-select"
                                                value={searchType}
                                                onChange={(e) => setSearchType(e.target.value)}
                                                style={{ height: "40px" }}
                                            >
                                                {searchOptions.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        {/* Search Input */}
                                        <div style={{ minWidth: '200px' }}>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={getPlaceholderText()}
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                style={{ height: "40px" }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Status Filter */}
                                <div className="col-md-auto col-12">
                                    <select
                                        className="form-select"
                                        value={selectedStatusFilter}
                                        onChange={(e) => setSelectedStatusFilter(e.target.value)}
                                        aria-label="Filter by status"
                                        style={{ maxWidth: '150px', height: "40px" }}
                                    >
                                        <option value="">All Status</option>
                                        <option value="APPROVED">Approved</option>
                                        <option value="PENDING">Pending</option>
                                        <option value="REJECTED">Rejected</option>
                                    </select>
                                </div>

                                {/* Clear Filters Button */}
                                <div className="col-md-auto col-12">
                                    <button
                                        className="btn"
                                        onClick={clearAllFilters}
                                        style={{
                                            backgroundColor: '#6c757d',
                                            color: '#fff',
                                            height: "40px",
                                            padding: "0 15px"
                                        }}
                                    >
                                        Clear Filters
                                    </button>
                                </div>
                                
                                {/* Export Button */}
                                <div className="col-md col-12">
                                    <div className="d-flex justify-content-start justify-content-md-end">
                                        <button 
                                            className="btn" 
                                            onClick={handleExport} 
                                            style={{ 
                                                backgroundColor: '#b15cd6', 
                                                color: '#fff',
                                                height: "40px",
                                                padding: "0 20px"
                                            }}
                                        >
                                            Export
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="user-table-wrapper" style={{ height: "500px", overflow: "auto" }}>
                                <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr>
                                            <th style={tableHeaderStyle}>S.NO</th>
                                            <th style={tableHeaderStyle}>Professional User ID</th>
                                            <th style={tableHeaderStyle}>Professional User Name</th>
                                            <th style={tableHeaderStyle}>Company Name</th>
                                            <th style={tableHeaderStyle}>Restaurants</th>
                                            <th style={tableHeaderStyle}>Approval Status</th>
                                            <th style={tableHeaderStyle}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((user, index) => {
                                                const overallStatus = getOverallStatus(user.restaurants);
                                                const approveLoading = loadingStates[`approve_${user.professionalUserId}`];
                                                const rejectLoading = loadingStates[`reject_${user.professionalUserId}`];
                                                
                                                return (
                                                    <tr
                                                        key={user.professionalUserId || user.sno}
                                                        style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
                                                    >
                                                        <td style={tableCellStyle}>{user.sno}</td>
                                                        <td style={tableCellStyle}>{user.professionalUserId}</td>
                                                        <td style={tableCellStyle}>{user.professionalUserName}</td>
                                                        <td style={tableCellStyle}>{user.companyName}</td>
                                                        <td style={tableCellStyle}>
                                                            {getRestaurantNames(user.restaurants)}
                                                        </td>
                                                        <td style={tableCellStyle}>
                                                            <span style={{
                                                                padding: '2px 8px',
                                                                borderRadius: '12px',
                                                                fontSize: '0.85rem',
                                                                fontWeight: 'bold',
                                                                backgroundColor: 
                                                                    overallStatus === 'APPROVED' ? '#d4edda' :
                                                                    overallStatus === 'REJECTED' ? '#f8d7da' :
                                                                    overallStatus === 'PENDING' ? '#fff3cd' : '#e2e3e5',
                                                                color: 
                                                                    overallStatus === 'APPROVED' ? '#155724' :
                                                                    overallStatus === 'REJECTED' ? '#721c24' :
                                                                    overallStatus === 'PENDING' ? '#856404' : '#383d41'
                                                            }}>
                                                                {overallStatus || "PENDING"}
                                                            </span>
                                                        </td>
                                                        <td style={tableCellStyle}>
                                                            <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                                                                {/* Show Approve button if status is not APPROVED (can be REJECTED, PENDING, or MIXED) */}
                                                                {overallStatus !== 'APPROVED' && (
                                                                    <button
                                                                        onClick={() => handleApprove(user.professionalUserId)}
                                                                        disabled={approveLoading}
                                                                        style={{
                                                                            backgroundColor: '#28a745',
                                                                            color: 'white',
                                                                            border: 'none',
                                                                            padding: '4px 12px',
                                                                            borderRadius: '4px',
                                                                            cursor: approveLoading ? 'not-allowed' : 'pointer',
                                                                            opacity: approveLoading ? 0.6 : 1,
                                                                            fontSize: '0.85rem'
                                                                        }}
                                                                    >
                                                                        {approveLoading ? 'Approving...' : 'Approve'}
                                                                    </button>
                                                                )}
                                                                
                                                                {/* Show Reject button only if status is PENDING (not when APPROVED or REJECTED) */}
                                                                {overallStatus === 'PENDING' && (
                                                                    <button
                                                                        onClick={() => handleReject(user.professionalUserId)}
                                                                        disabled={rejectLoading}
                                                                        style={{
                                                                            backgroundColor: '#dc3545',
                                                                            color: 'white',
                                                                            border: 'none',
                                                                            padding: '4px 12px',
                                                                            borderRadius: '4px',
                                                                            cursor: rejectLoading ? 'not-allowed' : 'pointer',
                                                                            opacity: rejectLoading ? 0.6 : 1,
                                                                            fontSize: '0.85rem'
                                                                        }}
                                                                    >
                                                                        {rejectLoading ? 'Rejecting...' : 'Reject'}
                                                                    </button>
                                                                )}
                                                                
                                                                {/* Show a status message when already approved */}
                                                                {overallStatus === 'APPROVED' && (
                                                                    <span style={{
                                                                        color: '#155724',
                                                                        fontSize: '0.85rem',
                                                                        fontWeight: 'bold',
                                                                        padding: '4px 8px'
                                                                    }}>
                                                                        ✓ Approved
                                                                    </span>
                                                                )}
                                                                
                                                                {/* Show a status message when rejected */}
                                                                {overallStatus === 'REJECTED' && (
                                                                    <span style={{
                                                                        color: '#721c24',
                                                                        fontSize: '0.85rem',
                                                                        fontWeight: 'bold',
                                                                        padding: '4px 8px'
                                                                    }}>
                                                                        ✗ Rejected
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="7" style={noDataStyle}>
                                                    {data.length === 0
                                                        ? "Loading data or no professional users found."
                                                        : (searchQuery.trim() || selectedStatusFilter)
                                                            ? "No users found with the specified filters."
                                                            : "No professional users available."}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: "6px",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "6px",
};

const noDataStyle = {
    fontStyle: "italic",
    textAlign: "center",
    padding: "10px",
    color: "#888",
};

export default PostPaidUsers;